<template>
    <transition
        v-bind:enter-active-class="enterActiveClass"
        v-bind:leave-class="status"
        v-bind:leave-active-class="leaveActiveClass"
        v-bind:leave-to-class="status">
        <div v-if="active" class="ui vue progress" v-bind:class="[componentClass, variant]">
            <div class="bar" v-bind:style="{width: `${progress}%`}"></div>
        </div>
    </transition>
</template>

<script>
export default {
    props: {
        enterTransition: {
            type: String,
            default: 'fade in'
        },
        leaveTransition: {
            type: String,
            default: 'fade out'
        },
        variant: {
            type: String
        },
        active: Boolean,
        maximum: {
            type: Number,
            default: 97
        },
        time: {
            type: Number,
            default: 1000
        },
        status: {
            type: String,
            default: 'success',
            validator(value) {
                return ['success', 'warning', 'error'].indexOf(value) !== -1
            }
        }
    },
    data() {
        return {
            progress: 0
        }
    },
    mounted() {
        //this.active && this.start()
    },
    destroyed() {
        this.stop()
    },
    watch: {
        active(value) {
            value ? this.start() : this.stop()
        }
    },
    computed: {
        componentClass() {
            return {
                active: this.active
            }
        },
        enterActiveClass() {
            return `transition ${this.enterTransition}`
        },
        leaveActiveClass() {
            return `transition ${this.leaveTransition} ${this.status}`
        }
    },
    methods: {
        start() {
            const calculate = () => {
                this.$_time += 100
                this.progress = ((this.maximum / 100 - Math.exp(-1 * this.$_time / this.time)) * 100).toFixed()
            }

            if (this.$_intervalId) {
                return
            }

            this.$_time = 0
            this.$_intervalId = setInterval(calculate, 100)
        },
        stop() {
            clearInterval(this.$_intervalId)
            this.$_intervalId = null
            this.progress = 0
        }
    }
}
</script>

<style>
    .ui.progress .bar {
        min-width: 0;
    }
    .ui.progress.success .bar,
    .ui.progress.error .bar,
    .ui.progress.warning .bar {
        min-width: 100% !important;
    }
</style>